<template>
  <base-modal
    :reference="'deleteActivityGroup_' + activity_group.id"
    :title="'Confirmación de eliminación de grupo de actividad'"
    :cancelActionText="'Cerrar'"
    :acceptAction="acceptAction"
    :size="'lg'"
  >
    <template v-slot:body v-if="show">
        <div>
            <p class="alert-info rounded-sm w-75 mx-auto py-2 px-2">
                Por favor, confirme que quiere borrar el grupo de actividad <strong>{{activity_group.name}}</strong>
            </p>
        </div> 
        <div>
            <p class="alert-warning w-50 font-weight-bold mx-auto py-2 px-2 mb-5">
                Tenga en cuenta que se borrará el grupo y cualquier relación con las paradas que tuviera configuradas el grupo
            </p>
            <b-button
                class="border mr-2 btn-danger font-weight-bold" style="color: white;"
                size="sm"
                variant=""
                @click="deleteActivityGroup(1)"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>

        </div>
    </template>
    <template v-slot:accept-action>
        <span></span>
    </template>

  </base-modal>
</template>

<script>
/* eslint-disable */

import BaseModal from "../../Excursions/Booking/Modal/BaseModal";

export default {
  components: {
    BaseModal,
  },
  props: {
    activity_group: {
        type: Object || undefined ,
        required: false,
    },
    suprazone: {
        type: Object,
        required: false,
    }
  },
  data() {
    return {
        show: false,
    }
  },
  async mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      const current = "deleteActivityGroup_" + this.activity_group.id;
      if (modalId == current) {
            this.show = true
      }
    });
  },
  beforeDestroy() {
  },
  methods: {
        
        async deleteActivityGroup(force) {
            let data = {
                activity_group_id: this.activity_group.id,
                force_delete: force
            }
            this.$store.dispatch('groups/deleteActivityGroup', data)
            .then( response => {
                this.$store.dispatch('groups/loadGroupsBySuprazone', {suprazone_id: this.suprazone.id})
                this.$notify({
                    group: "foo",
                    title: "El grupo de actividad se ha eliminado",
                    text: "El groupo de activida " + this.activity_group.name + " se ha eliminado satisfactoriamente",
                    type: "success",
                });
            })
            .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "El grupo de actividad no se puede eliminar",
                    text: "El grupo de actividad " + this.activity_group.name + " no se puede eliminar ya que tiene objetos vinculados (paradas)",
                    type: "error",
                });
            })
        },
        acceptAction() {
            this.$bvModal.hide('deleteActivityGroup_' + this.activity_group.id)
        }
  },
  
};
</script>